let featureFlags;
let lqFeatureFlags;

try {
  featureFlags = require("./feature-flags.json");
} catch {
  featureFlags = {};
}

try {
  lqFeatureFlags = require("./lq-feature-flags.json");
} catch {
  lqFeatureFlags = {};
}
const general = {
  language: "pl",
  pageTitle: "Ogłoszenia - Sprzedam, kupię na OLX.pl",
  regulationsUrl: "https://bliskapaczka.pl/regulaminy",
  policyUrl: "https://bliskapaczka.pl/static/pdf/polityka_prywatnosci.pdf",
  confirmationRegulationsUrl: "https://bliskapaczka.pl/regulaminy",
  regulationsOLXUrl:
    "https://bolt.my.site.com/olxplhelp/s/article/za%C5%82%C4%85cznik-nr-9-us%C5%82uga-dostawy-olx-V23-olx",
  confirmationPolicyUrl:
    "https://bliskapaczka.pl/static/pdf/polityka_prywatnosci.pdf",
  packageDeliveryInfoUrl: "https://pomoc.olx.pl/hc/pl/articles/360012356279",
  packageDeliveryBuyerManualUrl:
    "https://pomoc.olx.pl/hc/pl/articles/360012241920",
  packageDeliverySellerManualUrl:
    "https://pomoc.olx.pl/hc/pl/articles/360012357179",
  eligibleCategoriesUrl: "https://pomoc.olx.pl/hc/pl/articles/360015319020",
  moreInfoAboutDeliveryUrl:
    "https://pomoc.olx.pl/hc/pl/categories/360002373540-Przesyłki-OLX",
  rewardInfoUrl: "https://www.olx.pl/d/mojolx/programy-lojalnosciowe",
  discountInfoUrl: "https://pomoc.olx.pl/hc/pl/sections/360005332400",
  createTicketUrl:
    "https://pomoc.olx.pl/hc/pl/requests/new?ticket_form_id=227685",
  api: {
    staging: "https://delivery-api.stg.01.eu-west-1.eu.olx.org",
    production: "https://delivery-api.prd.01.eu-west-1.eu.olx.org",
  },
  unifiedPlatformAPI: {
    staging: "https://pl.ps.stg.eu.olx.org",
    production: "https://pl.ps.prd.eu.olx.org",
  },
  donationPolishHumanitarianAction:
    "https://media.olx.pl/uzytkownicy-olx-moga-wspierac-polska-akcje-humanitarna",
  donationRegulations:
    "https://pomoc.olx.pl/hc/pl/articles/360000828525",
  pageDescription:
    "OLX.pl to darmowe ogłoszenia lokalne w kategoriach: Praca, Dom i Ogród, Elektronika, Moda, Rolnictwo, Zwierzęta. Dla Dzieci, Sport i Hobby, Muzyka i Edukacja, Usługi i Firmy. Szybko znajdziesz tu ciekawe ogłoszenia i łatwo skontaktujesz się z ogłoszeniodawcą. Na OLX.pl czeka na Ciebie m.in. praca biurowa, mieszkania, pokoje, samochody. Jeśli chcesz coś sprzedać - w prosty sposób dodasz ogłoszenia. Chcesz coś kupić - tutaj znajdziesz ciekawe okazje, taniej niż w sklepie. A wszystkie te ogłoszenia bez konieczności zakładania konta. Sprzedawaj po sąsiedzku na OLX.pl",
  actionPaths: {
    addAd: "/nowe-ogloszenie/?bs=delivery_orders",
    myAds: "/mojolx/active/",
    myProfile: "/konto/menu/",
    messages: "/mojolx/odpowiedzi/",
    watching: "/obserwowane/",
    search: "/searchform/",
    myAccount: "/mojolx/",
    messagesDesktop: "/mojolx/wiadomosci/",
    payments: "/mojolx/portfel/",
    settings: "/mojolx/ustawienia/",
    login: "/konto/",
    logout: "/konto/wyloguj/",
    authorize: "/konto/",
  },
  deliveryPaths: {
    checkout: "/checkout",
    sellerConfirmation: "/orders/confirmation",
    ordersBuying: "/orders/purchases",
    ordersSelling: "/orders/sales",
    verification: "/orders/verification",
    dac7: "/orders/dac7",
    returns: "/orders/returns",
    returnsForm: "/returns/form",
    desktopVerification: "/mojolx/dostawy/verification",
    desktopOrders: "/mojolx/dostawy/",
    desktopOrdersBuying: "/mojolx/dostawy/purchases",
    desktopOrdersSelling: "/mojolx/dostawy/sales",
    desktopReturns: "/mojolx/dostawy/returns",
    safeDealReport: "/safedeal/report",
    safeDealReportSuccess: "/safedeal/report-success",
    safeDealSuccess: "/safedeal/success",
  },
  chatPaths: {
    conversation: "/myaccount/answer/",
  },
  sentry: {
    dsn: "https://021258cb5cd347ffb7e0372c8fb919e5@sentry.io/1516932",
  },
  map: {
    version: "quarterly",
    center: [51.9194, 19.1451],
    libraries: ["places"],
  },
  country: {
    phonePrefix: "+48",
    ibanPrefix: "PL",
  },
  package: {
    maxDimensions: "19x38x64 cm",
    maxWeight: "5 kg",
  },
};

const production = (() => {
  const domain = "olx.pl";
  const desktopUrl = `https://www.${domain}`;

  return {
    ...general,
    environment: "production",
    featureFlags: featureFlags.production,
    sites: {
      desktop: {
        domain,
        url: desktopUrl,
      },
      mweb: {
        domain,
        url: `https://m.${domain}`,
      },
      delivery: {
        domain: `delivery.${domain}`,
        url: `https://delivery.${domain}`,
      },
    },
    map: {
      ...general.map,
      googleKey: "AIzaSyANYD0d-GIHcnlLmmyENxkURPuKwWVlolo",
    },
    atlasSDK: {
      server: desktopUrl,
      version: "v1",
    },
    deliverySDK: {
      server: "Server-1",
    },
    chatSDK: {
      server: "https://api.chat.olx.pl",
    },
  };
})();

const staging = (() => {
  const domain = "pl.stg.eu.olx.org";
  const desktopUrl = `https://www.${domain}`;
  const mWebUrl = `https://m.${domain}`;

  return {
    ...general,
    environment: "staging",
    featureFlags: featureFlags.staging,
    sites: {
      desktop: {
        domain,
        url: desktopUrl,
      },
      mweb: {
        domain,
        url: mWebUrl,
      },
      delivery: {
        domain: `delivery.${domain}`,
        url: `https://delivery.${domain}`,
      },
    },
    map: {
      ...general.map,
      googleKey: "AIzaSyDCkdsCxix-Omwo3LiAXStWWTvBsqsdGO4",
    },
    atlasSDK: {
      server: desktopUrl,
      version: "v1",
    },
    deliverySDK: {
      server: "Server-1",
    },
    chatSDK: {
      server: "https://api-olxpl.chat.stg.eu.olx.org",
    },
    rewardInfoUrl: `${desktopUrl}/d/mojolx/programy-lojalnosciowe`,
  };
})();

const localhost = (() => {
  const domain = "pl.stg.eu.olx.org";
  const desktopUrl = `https://www.${domain}`;
  const mWebUrl = `https://m.${domain}`;

  return {
    ...general,
    environment: "localhost",
    featureFlags: { ...featureFlags.staging, ...lqFeatureFlags },
    sites: {
      desktop: {
        domain,
        url: desktopUrl,
      },
      mweb: {
        domain,
        url: mWebUrl,
      },
      delivery: {
        domain: `localhost`,
        url: `http://localhost:8080`,
      },
    },
    map: {
      ...general.map,
      googleKey: "AIzaSyACH1ESm99hlQcyDfM5I_A9iBxSV8HmD68",
    },
    atlasSDK: {
      server: "http://localhost:8080",
      version: "v1",
    },
    deliverySDK: {
      server: "Server-1",
    },
    chatSDK: {
      server: "https://api-olxpl.chat.stg.eu.olx.org",
    },
  };
})();

const test = (() => {
  const domain = "olxtech.pl";
  const desktopUrl = "https://www.pl.stg.eu.olx.org";
  const mWebUrl = "https://m.pl.stg.eu.olx.org";

  return {
    ...staging,
    sites: {
      desktop: {
        domain,
        url: desktopUrl,
      },
      mweb: {
        domain,
        url: mWebUrl,
      },
      delivery: {
        domain: `test-staging.delivery-pl.${domain}`,
        url: `https://test-staging.delivery-pl.${domain}`,
      },
    },
  };
})();

module.exports = {
  allFeatureFlags: featureFlags,
  environments: {
    production,
    staging,
    localhost,
    test,
  },
};
